import React from "react";

import { Box } from "@mui/material";

import Text from "@src/sharedComponents/Typography/Text";

interface DynamicTitleHeaderProps {
  title?: string;
}

const DynamicTitle: React.FC<DynamicTitleHeaderProps> = ({ title }) => {
  const displayTitle = title && title.trim();

  return (
    <Box>
      <Text variant="title2">{displayTitle}</Text>
    </Box>
  );
};

export default DynamicTitle;
